/* Mobile helpers */

/* 1) Live banner: auto-cycle the featured pack (touch devices can't hover). */
(function () {
  var root = document.querySelector('[data-na-live]');
  if (!root || !window.matchMedia) return;
  if (!matchMedia('(hover: none)').matches) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var player = root.querySelector('[data-na-player]');
  if (!player) return;
  var visible = false, i = 0, idle = 0;
  new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(player);
  player.addEventListener('touchstart', function () { idle = Date.now(); }, { passive: true });
  setInterval(function () {
    if (!visible || document.hidden || Date.now() - idle < 6000) return;
    var slots = ['1', '2', '3', '4'];
    for (var n = 0; n < 4; n++) {
      var s = slots[(i + n) % 4];
      var p = player.querySelector('.na-live__pack[data-slot="' + s + '"]');
      if (p) { i = (i + n + 1) % 4; p.click(); break; }
    }
  }, 3400);
})();

/* 2) Trust strip on phones: swipe row. The card nearest the centre is raised out of the box; the rest sit lower. */
(function () {
  var wrap = document.querySelector('[data-na-trust]');
  if (!wrap || !window.matchMedia) return;
  var mq = matchMedia('(max-width: 750px)');
  var cards = [].slice.call(wrap.querySelectorAll('.na-tc'));
  var stage = wrap.parentNode;
  var tag = document.createElement('div');
  tag.className = 'na-trust__swipe';
  tag.setAttribute('aria-hidden', 'true');
  tag.innerHTML = 'Swipe <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';
  stage.appendChild(tag);
  var ticking = false;
  function update() {
    ticking = false;
    if (!mq.matches) { cards.forEach(function (c) { c.classList.remove('is-active'); }); return; }
    var mid = wrap.scrollLeft + wrap.clientWidth / 2, best = null, bd = 1e9;
    cards.forEach(function (c) {
      var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
      if (d < bd) { bd = d; best = c; }
    });
    cards.forEach(function (c) { c.classList.toggle('is-active', c === best); });
    stage.classList.toggle('is-scrolled', wrap.scrollLeft > 24);
  }
  wrap.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  cards.forEach(function (c) {
    c.addEventListener('click', function () {
      if (!mq.matches) return;
      wrap.scrollTo({ left: c.offsetLeft - (wrap.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
    });
  });
  if (mq.matches) wrap.scrollLeft = 0;
  window.addEventListener('resize', update);
  update();
})();